/* Orléa — LES PRODUITS ÉPUISÉS NE S'AFFICHENT PAS PAR DÉFAUT

   ╔══ LA DEMANDE (Simon, 2026-07-30) ════════════════════════╗
   > « Est-ce qu'il y a une façon de montrer toujours juste les produits
   >   in stock ? Et dans les filtres, on est capable de choisir après
   >   ça de voir les produits qui ne sont pas en stock. »

   Contexte : le tri BEST_SELLING de Shopify IGNORE le stock. Deux Lip
   Oil épuisés trustaient la tête de grille (mesuré : 4 épuisés / 138).

   ╔══ POURQUOI EN JS ET PAS DANS LA COLLECTION ═════════════════╗
   Ajouter une règle « stock > 0 » à `shop-all` les RETIRERAIT de la
   collection : plus moyen de les afficher, même par un filtre. Et
   `shop-all` est PUBLIQUE — la règle s'appliquerait aussi au thème live.
   Ici, les produits restent dans la collection ; on ne fait que
   pré-cocher un filtre que Shopify expose déjà (`filter.v.availability`,
   vérifié : 134 en stock / 4 épuisés).

   ╔══ LES GARDE-FOUS — chacun empêche un vrai bug ══════════════╗

   1. URL DÉJÀ PARAMÉTRÉE → on ne touche à rien. Sans ça, un visiteur
      qui coche « Out of stock » serait immédiatement remis sur
      « In stock » : le filtre deviendrait inutilisable, soit exactement
      le contraire de la demande.

   2. 🔴 LE MARQUEUR N'EST POSÉ QU'APRÈS AVOIR DÉCIDÉ DE REDIRIGER.
      Première version : je l'écrivais AVANT le test de l'URL. Résultat
      mesuré — une arrivée sur `?preview_theme_id=...` (URL paramétrée,
      donc pas de redirection) posait quand même le marqueur, et la
      visite suivante sur l'URL nue était bloquée par lui. Le script ne
      s'exécutait jamais vraiment.
      → Règle : n'enregistrer un état qu'une fois l'action accomplie.

   3. Le marqueur sert à respecter un RETRAIT VOLONTAIRE du filtre : si
      le visiteur revient à l'URL nue après avoir tout décoché, on ne le
      force pas en boucle.

   4. `replace()` et non `assign()` → le bouton Retour ne rebondit pas
      entre les deux URL.

   5. Uniquement sur `/collections/` — jamais sur la recherche ni ailleurs.

   ⚠ Le filtre reste ENTIÈREMENT accessible : le tiroir affiche
   « Availability » avec In stock / Out of stock, et décocher montre tout.

   Rollback : retirer sa ligne de `orlea-filtres-css.liquid`.
*/
(function () {
  'use strict';

  var CLE = 'orlea-stock-defaut';
  var PARAM = 'filter.v.availability';

  // 5. seulement les pages collection
  if (window.location.pathname.indexOf('/collections/') !== 0) return;

  // 1. une URL déjà paramétrée est un CHOIX du visiteur : on n'y touche pas.
  //    ⚠ AUCUN effet de bord ici — surtout pas d'écriture de marqueur.
  var q = window.location.search;
  if (q && q !== '?') return;

  var marque = CLE + ':' + window.location.pathname;

  // 3. le visiteur a déjà été redirigé sur cette collection dans cet
  //    onglet, puis est revenu à l'URL nue : c'est un retrait volontaire.
  try {
    if (sessionStorage.getItem(marque)) return;
  } catch (e) {
    // navigation privée ou stockage bloqué : on redirige quand même,
    // le garde-fou n°1 suffit à éviter toute boucle.
  }

  var u = new URL(window.location.href);
  u.searchParams.set(PARAM, '1');

  // 2. le marqueur N'EST POSÉ QU'ICI, une fois la décision prise.
  try { sessionStorage.setItem(marque, '1'); } catch (e) {}

  // 4. replace : pas d'entrée parasite dans l'historique
  window.location.replace(u.toString());
})();
